import * as Yup from 'yup';
import i18next from 'i18next';

export const addTransactionSchema = () =>
  Yup.object().shape({
    amount: Yup.string().required(i18next.t('validation.required')),
    description: Yup.string().required(i18next.t('validation.required')),
  });
